var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHitNext = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5c-.294 0-.573-.13-.763-.354l-11-13a1 1 0 1 1 1.526-1.292L12 16.952 22.237 4.854a1 1 0 1 1 1.526 1.291l-11 13A1 1 0 0 1 12 19.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHitNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hit_next.svg";